import { magicLinkClient } from "better-auth/client/plugins"
import { createAuthClient } from "better-auth/react"

export const authClient = createAuthClient({
	baseURL: process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:4000",
	basePath: "/auth",
	plugins: [magicLinkClient()],
})

export const { signIn, signUp, signOut, useSession } = authClient
